import React from 'react';
import { FaUserNurse } from "react-icons/fa";
import { FaUserDoctor, FaBookOpenReader } from "react-icons/fa6";
import { HiAcademicCap } from "react-icons/hi2";

const HomeTutorPoints = () => {
    return (
        <div className='homeTutorPoints'>
            <div className="container">
                <div className="homeTutorPointsMain">
                    <div className="homeTutorPointsBox">
                        <div className="homeTutorPointsBoxIcon">
                            <FaUserNurse />
                        </div>
                        <div className="homeTutorPointsBoxDetails">
                            <h2>Experienced Nurse Educator</h2>
                            <p>MSc MSN graduate with extensive teaching experience.</p>
                        </div>
                    </div>
                    <div className="homeTutorPointsBox">
                        <div className="homeTutorPointsBoxIcon">
                            <FaUserDoctor />
                        </div>
                        <div className="homeTutorPointsBoxDetails">
                            <h2>Clinical <br />Expertise</h2>
                            <p>Worked as a Registered Nurse at PD Hinduja Hospital, Mumbai.</p>
                        </div>
                    </div>
                    <div className="homeTutorPointsBox">
                        <div className="homeTutorPointsBoxIcon">
                            <HiAcademicCap />
                        </div>
                        <div className="homeTutorPointsBoxDetails">
                            <h2>Academic <br />Excellence</h2>
                            <p>Completed nursing education at Sir HN Hospital & Rajiv Gandhi University.</p>
                        </div>
                    </div>
                    <div className="homeTutorPointsBox">
                        <div className="homeTutorPointsBoxIcon">
                            <FaBookOpenReader />
                        </div>
                        <div className="homeTutorPointsBoxDetails">
                            <h2>Exam Preparation Specialist</h2>
                            <p>Trains nurses for NCLEX RN, DHA, HAAD, Prometric, and other licensing exams.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeTutorPoints;